import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  theme: any;
  isSpread?: boolean;
}

export const Wrapper = styled.div<IProps>`
  width: 100%;
  box-sizing: border-box;
  overflow-x: scroll;
  padding: ${rem(8)} ${0};
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    display: none;
    height: 0;
    background-color: transparent;
  }
`;

export const TabList = styled.div<IProps>`
  display: inline-flex;
  width: max-content;
  gap: ${rem(8)};
  ${({ isSpread }) =>
    isSpread &&
    `
    flex-wrap: wrap;
    width: fit-content;
  `}
`;
